export default function getDefaultState () {
  return { clients: {} }
}
